import React from "react";
import { LoadingIcon } from "../../elements";

export const Loading = (props: { message: string }) => (
  <div style={{ padding: "4rem", textAlign: "center" }}>
    <LoadingIcon isHighlightColor={false} />
    <p style={{ textTransform: "uppercase" }}>{props.message}</p>
  </div>
);
